import React, { useState, VoidFunctionComponent } from "react";
import { BottomLayout } from "@/components/responsive/product/layer/bottomLayout/BottomLayout";
import { Button } from "@/components/responsive/commun/button";
import { Send } from "@/assets//images/responsive/icons/send";
import { FormQuestion } from "@/components/responsive/product/layer/question/FormQuestion";
import { useDispatch, useSelector } from "react-redux";
import { askQuestion } from "@/redux/reducers/responsive/product/questionsAction";
import { RootState } from '@/models/appState/RootState';
import { HANDLE_ASK_QUESTION_LOADER } from "@/redux/reducers/responsive/actionsTypes";
import { PlaceholderBlock } from "@/components/responsive/product/placeholderBlock/PlaceholderBlock";
import { PLACEHOLDER_TYPE } from "@/utils/constants";

interface Props {
    setQuestionIsSend: (questionIsSend: boolean) => void,
    questionIsSend: boolean,
    productId: string
}

export const AskQuestion: VoidFunctionComponent<Props> = ({ questionIsSend, setQuestionIsSend, productId }) => {
    const [isChecked, setIsChecked] = useState(false);
    const [question, setQuestion] = useState('');
    const [pseudo, setPseudo] = useState('');
    const [email, setEmail] = useState('');
    const dispatch = useDispatch();
    const questionsData = useSelector((state: RootState) => state.questions);

    const isOkToSend = isChecked && question.length >= 10 && pseudo.length > 1 && email.length > 1;

    const sendQuestion = (): void => {
        dispatch(askQuestion({
            "email": email,
            "content": question,
            "pseudo": pseudo,
            "productId": productId
        }))
        dispatch({ type: HANDLE_ASK_QUESTION_LOADER, payload: { isPending: true } })
        setQuestionIsSend(true);
        setQuestion('');
        setEmail('');
        setPseudo('');
        setIsChecked(false);

    };

    const renderBottom = (): JSX.Element => {
        return (
            <BottomLayout>
                <div className='bottom-button'>
                    <Button type='adaptive' enabled={isOkToSend} callBack={sendQuestion}>
                        <div className={`button-label ${isOkToSend ? '' : 'disable'} `}>
                            <Send />
                            <p className='uppercase'>Poster ma question</p>
                        </div>
                    </Button>
                </div>
            </BottomLayout>
        );
    };

    const renderConfirmation = (successSend?: boolean, isPending?: boolean): JSX.Element => {
        if (isPending) {
            return <div className='confirmation'><PlaceholderBlock type={PLACEHOLDER_TYPE.PICKUP}
                borderRadius={true} /></div>
        }
        if (successSend === true) {
            return (
                <div className='confirmation'>
                    <p className='title'>Votre question a bien été envoyée</p>
                    <p className='body'>
                        Un email vient de vous être envoyé pour valider votre question
                    </p>
                </div>

            );
        } else {
            return (
                <div className=' errorMessage confirmation'>
                    <p className='title'>Veuillez réessayer</p>
                    <p className='body'>
                        Un problème est survenu lors de l’envoi de votre question
                    </p>
                </div>

            );
        }

    };

    const renderForm = (): JSX.Element => {
        return (
            <FormQuestion
                isChecked={isChecked}
                setIsChecked={setIsChecked}
                question={question}
                setQuestion={setQuestion}
                pseudo={pseudo}
                setPseudo={setPseudo}
                email={email}
                setEmail={setEmail}
            />
        );
    };

    const renderHeader = (): JSX.Element => {
        return (
            <p className='description'>
                Attention, votre question doit concerner ce produit. Pour toute autre
                question (disponibilité, SAV...) rendez-vous sur la rubrique{' '}
                <a
                    href='https://www.but.fr/aide'
                    rel='noreferrer noopener'
                    target='_blank'
                >
                    Aide
                </a>
            </p>
        );
    };

    return (
        <div className='ask-question-layer'>
            {questionIsSend ? (
                renderConfirmation(questionsData.successSend, questionsData.isPending)
            ) : (
                <>
                    <div className='ask-question'>
                        {renderHeader()}
                        {renderForm()}
                    </div>
                    {renderBottom()}
                </>
            )}
        </div>
    );
};